export default __webpack_public_path__ + "static/media/success.abee57ed.svg";